export const clearAsync = (key: string): void => {
    window.sessionStorage.removeItem(key)
}
